<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding bank-edit sidebar-dialog">
    <div class="sidebar-content h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="dialog-title">
          {{barTitle}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <p class="theme-color mar-bot20">*{{$t('bind365_tips')}}</p>
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-row :gutter="30">
              <el-col :lg="24" :md="24" :sm="24" :xs="24">
                <el-form-item
                  :label="$t('Choose_verification_method')"
                  prop="codeType"
                >
                  <el-select
                    style="width: 100%"
                    class="select-type"
                    v-model="form.type"
                  >
                    <el-option
                    v-for="(item,index) in availableTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="verCode"
                  :label="$t('Register.verText')"
                >
                  <div class="code-box pr">
                    <el-input
                      v-model="form.verCode"
                      :placeholder="phFileter('Register.verText')"
                    ></el-input>
                    <div
                      class="sendMes pa theme-color"
                    >
                      <span
                        v-if="isCode"
                        @click="getCode"
                        class="active code-span"
                      >{{$t('User.sendVeri')}}</span>
                      <span
                        class="code-span code-span"
                        v-else
                      >{{isCodeNumber}}s {{$t('User.sendDesc')}}</span>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item
                  :label="`${$t('address')}(TRC20/BEP20)`"
                  prop="address"
                >
                  <el-input
                    v-model="form.address"
                    :placeholder="$t('Please_fill_out')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              :label="`${$t('QR_code')}（TRC20/BEP20）`"
              prop="qrPic"
            >
              <upload-img-tips></upload-img-tips>
              <div class="upload-box pr">
                <MobileImageUpload
                  :value="form.qrPic"
                  @input="(url) => { form.qrPic = url }"
                  @success="(url) => { form.qrPic = url }"
                >
                  <img
                    v-if="form.qrPic"
                    :src="form.qrPic"
                    class="avatar middle"
                  >
                  <div v-else class="avatar-uploader-btn">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                </MobileImageUpload>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
        :disabled="submitLoading"
      >
        <span v-if="submitLoading"><i class="el-icon-loading"></i> </span>
        {{$t('Register.submitText')}}
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { limitImageSizeFormat } from "@/utils/common";
import { mapGetters, mapActions } from 'vuex'
import { getCustPayTypes,getSendVerWallet,updateUsdtOrOtcInfo } from '@/api/user.js';
// 需要重新联调 确认需求
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "barInfoEditDialog",
  components:{
    VuePerfectScrollbar
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    barTitle: {
    },
    channelInfo: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    let _this = this;
    let validateUsdtAddress = (rule, value, callback) => {
      if (!_this.isUsdtChannel() || !value) {
        callback();
        return;
      }
      if (_this.isValidUsdtAddress(value)) {
        callback();
        return;
      }
      callback(new Error(_this.$t('Please_enter_valid_usdt_address')));
    };
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      typeList: [
        {
          label: this.$t('Login.emailVer'),
          value: 2
        },
        {
          label: this.$t('Login.phoneVer'),
          value: 1,
        }
      ],

      form:{
        type: 2,
        verCode: '',
        address: '',
        qrPic: '',
      },
      rules: {
        verCode: [
          { required: true, message: _this.$t('Partner.inputVer'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: _this.$t('Please_fill_in_the_address'), trigger: 'blur' },
          { validator: validateUsdtAddress, trigger: 'blur' }
        ],
        qrPic: [
          { required: true, message: _this.$t('Please_upload_the_QR_code'), trigger: 'blur' }
        ],
        bankFrontUrl: '',
        bankBackUrl: '',
      },
      isCode: true,
      isCodeNumber: 60,
      codeLoading: false,
      submitLoading: false,
      qrLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo','custPayTypes', 'smsVerificationEnabled']),
    availableTypeList(){
      return this.smsVerificationEnabled
        ? this.typeList
        : this.typeList.filter((option) => option.value !== 1);
    },
    verificationType(){
      return this.smsVerificationEnabled ? this.form.type : 2;
    },
  },
  watch: {
    custPayTypes: {
      handler(newVal) {
        if (newVal) {
          this.queryPayTypes();
        }
      },
      immediate: true
    }
  },
  created(){
  },
  methods: {
    ...mapActions(['refreshCustPayTypes']),
    isUsdtChannel(){
      let channelInfo = this.channelInfo || {};
      return this.barTitle === 'USDT' || channelInfo.payTypeId == 5 || channelInfo.payTypeId == 8;
    },
    isValidUsdtAddress(address){
      let value = (address || '').trim();
      // TRC20 is a Tron Base58 address; BEP20 is an EVM-style hex address.
      return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(value) || /^0x[a-fA-F0-9]{40}$/.test(value);
    },
    queryPayTypes(){
      const data = this.custPayTypes;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if(data[i].id == this.channelInfo.id){
            this.form.address = data[i].payDetailMap.address;
            this.form.qrPic = data[i].payDetailMap.qrPic;
            break;
          }
        }
      }
    },
    phFileter(data) {
      return this.$t(data);
    },
    // 上传图片的限制
    beforeAvatarUpload(file){
      return limitImageSizeFormat(file,this);
    },
    uploadCodeHandle(item){

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);
        this.qrLoading = true;
        this.$uploadFile(file).then((res) => {
          this.qrLoading = false;
          this.form.qrPic = res.data.data.content[0].url;
        }).catch((err) => {
          this.qrLoading = false;
        })
      });

    },
    submitHandle(){
      if (this.submitLoading) return;
      if(this.isUsdtChannel()){
        this.form.address = (this.form.address || '').trim();
      }
      this.$refs.form.validate((valid) => {
        if(valid){

          let parmas = {
            id: this.channelInfo.id,
            ...this.form,
          };
          this.submitLoading = true;
          updateUsdtOrOtcInfo(parmas).then(() => {
            return this.refreshCustPayTypes();
          }).then(() => {
            this.$message({
              message: this.$t('Partner.commitSuccess'),
              type: 'success'
            });
            this.$emit('ajax-success');
          }).finally(() => {
            this.submitLoading = false;
          });
        }
      })
    },
    getCode() {
      if (this.codeLoading || !this.isCode) return;
      this.codeLoading = true;
      getSendVerWallet({
        type: this.verificationType
      }).then((res) => {
        this.$message({
          message: this.$t('User.verCodeSendSuccess'),
          type: 'success'
        });
        this.isCode = false;
        this.timerOut();
        this.isCodeNumber = 60;
      }).finally(() => {
        this.codeLoading = false;
      });
    },
    timerOut() {
      let _this = this;
      let timer1 = setTimeout(() => {
        clearTimeout(timer1);
        if (_this.isCodeNumber > 0) {
          _this.isCodeNumber = --_this.isCodeNumber;
          _this.timerOut();
        } else {
          clearTimeout(timer1);
          this.isCode = true;
        }
      }, 1000);
    },

    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    cancelHandle(){
      this.close();
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.bank-edit {
  .content {
    padding-top: 10px;
    .text-box {
      background-color: #F8F8F8;
      padding: 10px;
      border-radius: 6px;
      .text-box-line {
        margin-bottom: 10px;
        font-size: 14px;
        .text-left {
          color: #A29FAE;
        }
        .data-right {
          color: #6E6B7B;
        }
      }
    }
  }
  .avatar {
    width: 100px;
    height: 100px;
  }
  .avatar-uploader {
    display: inline-block;
  }
  .avatar-uploader-btn {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 2px dashed #D8D6DE;
  }
  .sendMes {
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    text-align: right;

    .code-span {
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.bank-edit {
  .dialog-title {
    font-weight: bold;
  }
  .vs-sidebar--items {

  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
